import { Checkbox } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { ChangeEvent } from "react";

import {
  StyledCheckboxBlock,
  StyledCheckboxHint,
  StyledCheckboxLabel,
} from "./styles";

interface CheckboxWithLabelProps {
  fieldId: string;
}

function CheckboxWithLabel({ fieldId }: CheckboxWithLabelProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const field = findFieldById(fieldId);
  const value = field.value.asBool();

  const writable = field.writable;
  const required = field.required;

  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);
  const helper = field.hasHelper()
    ? translateField(translator, field, Suffix.HELP).toString()
    : "";

  const isChecked = value.value() || value.defaultValue();

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    field.setValue(event.target.checked);
  };

  return (
    <StyledCheckboxBlock>
      <StyledCheckboxLabel>
        <Checkbox
          onChange={handleCheckboxChange}
          checked={isChecked}
          disabled={!writable}
          required={required}
          size={"medium"}
          key={field.id()}
          dataTestId={`${dataTestIdPrefix}-${field.id()}`}
        />
        {label.toString()}
      </StyledCheckboxLabel>
      {helper && <StyledCheckboxHint>{helper}</StyledCheckboxHint>}
    </StyledCheckboxBlock>
  );
}

export default CheckboxWithLabel;
